import { render, staticRenderFns } from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=template&id=3ba5d0ce&scoped=true"
import script from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=style&index=0&id=3ba5d0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5d0ce",
  null
  
)

export default component.exports